import {AutoGroupService} from './autoGroupService.js';
import {AutoUnitService} from './autoUnitService.js';
import {DriverService} from './driverService.js';
import {TractorService} from './tractorService.js';
import {TrailerService} from './trailerService.js';
import {UnitGroupService} from './unitGroupService.js';
import {UnitMatchingService} from './unitMatchingService.js';
import {UnitLookupService} from './unitLookupService.js';
import {AdminUnitService} from './adminUnitService.js';

export var UnitService = {
    autoUnitService: null,
	autoGroupService: null,
	unitMatchingService: null,
	unitLookupService: null,
	tractorService: null,
	trailerService: null,
	driverService: null,
	unitGroupService: null,
	adminUnitService: null,

	getAutoUnitService: function () {
		if (!this.autoUnitService) {
			this.autoUnitService = new AutoUnitService();
		}
		return this.autoUnitService;
	},

	getAutoGroupService: function () {
		if (!this.autoGroupService) {
			this.autoGroupService = new AutoGroupService();
		}
		return this.autoGroupService;
	},
	
    getUnitMatchingService: function () {
		if (!this.unitMatchingService) {
			this.unitMatchingService = new UnitMatchingService();
		}
		return this.unitMatchingService;
	},
	
    getUnitLookupService: function () {
		if (!this.unitLookupService) {
			this.unitLookupService = new UnitLookupService();
		}
		return this.unitLookupService;
	},
	
	getTractorService: function () {
		if (!this.tractorService) {
			this.tractorService = new TractorService();
		}
		return this.tractorService;
	},
	
	getTrailerService: function () {
		if (!this.trailerService) {
			this.trailerService = new TrailerService();
		}
		return this.trailerService;
	},
	
	getDriverService: function () {
		if (!this.driverService) {
			this.driverService = new DriverService();
		}
		return this.driverService;
	},
	
	getUnitGroupService: function () {
		if (!this.unitGroupService) {
			this.unitGroupService = new UnitGroupService();
		}
		return this.unitGroupService;
	},
	
	getAdminUnitService: function () {
		if (!this.adminUnitService) {
			this.adminUnitService = new AdminUnitService();
		}
		return this.adminUnitService;
	}		

};


